uniform float uTime;
uniform float uTextFrequency;
uniform float uTextElevation;
uniform float uTextSpeed;

varying vec2 vUv;

void main() {



    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Elevation
    float elevation = sin(modelPosition.x * uTextFrequency + (uTime * uTextSpeed) ) * uTextElevation;
    
    modelPosition.y += elevation;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;



    gl_Position = projectionPosition;
    vUv = uv;
}